module.exports = __webpack_public_path__ + "static/media/avatar.cc65e71f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.svg
// module id = 1952
// module chunks = 1